import type { InferOutput } from "valibot";

export const preOrderItemSchema = v.object({
  product: productDocumentSchema,
  order_id: v.number(),
});
export type PreOrderItem = InferOutput<typeof preOrderItemSchema>;

export const myPreOrdersSchema = v.object({
  items: v.array(preOrderItemSchema),
});
export type MyPreOrders = InferOutput<typeof myPreOrdersSchema>;
